import { ShoppingCart } from 'lucide-react'
import { useCartCount, useCartStore } from '@/modules/cart'

export function CartBadge() {
  const count = useCartCount()
  const openDrawer = useCartStore((s) => s.openDrawer)

  return (
    <button
      type="button"
      onClick={openDrawer}
      className="flex items-center gap-3 shrink-0 group"
      aria-label="Mở giỏ hàng"
    >
      <div className="relative w-11 h-11 rounded-full bg-brand-50 flex items-center justify-center text-brand-600 group-hover:bg-brand-100 transition">
        <ShoppingCart className="w-5 h-5" />
        {count > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-danger text-white text-[11px] font-semibold flex items-center justify-center">
            {count}
          </span>
        )}
      </div>
      <div className="leading-tight text-left">
        <div className="text-sm font-semibold text-text">Giỏ hàng</div>
      </div>
    </button>
  )
}
